export const ROLE_OPTIONS = [
  { label: "Admin", value: "ADMIN.", bgColor: "#78DD8E", color: "black" },
  {
    label: "Director de Obra",
    value: "DIR.OBRA",
    bgColor: "#FF9DE4",
    color: "black",
  },
  {
    label: "Director de Proyecto",
    value: "DIR.PROYECTO",
    bgColor: "#ECAD80",
    color: "black",
  },
  {
    label: "Arquitecto",
    value: "ARQUITECTO",
    bgColor: "#758FFB",
    color: "black",
  },
]
